import {ActionEnum} from "../action.enum";

export namespace CompanyContactInfoOverlayAction {

  export class OpenInfoOverlay {
    static readonly type: ActionEnum = ActionEnum.COMPANY_CONTACT_INFO_OVERLAY_OPEN;

    constructor(public companyContactId: number, public selectedContactId: number = null) {}

  }

  export class CloseInfOverlay {
    static readonly type: ActionEnum = ActionEnum.COMPANY_CONTACT_INFO_OVERLAY_CLOSE;
  }
}
